import type { PointStyles } from "~/types";
import { getProvider } from "~/hooks";
import { AsyncMedia } from "./AsyncMedia";

export default function CustomMarker({ icon, ...props }: PointStyles) {
  const provider = getProvider(icon);

  return (
    <AsyncMedia
      media={{ file: icon, provider, type: "image" }}
      className="h-full w-full rounded-md overflow-hidden"
      alt="icon image"
    />
  );
}
